"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils");

var styles = {
  "container": "text-field-container-1W0Hy",
  "helper": "text-field-helper-2vqOg",
  "small": "text-field-small-3whyF",
  "large": "text-field-large-245JZ",
  "focus": "text-field-focus-1hyk3",
  "success": "text-field-success-1OCQF",
  "error": "text-field-error-1Ow1I"
};

/**
 * Unique ID generator
 *
 * Based on @gordonbrander's gist.
 * See: https://gist.github.com/gordonbrander/2230317
 *
 * > Math.random should be unique because of its seeding algorithm.
 * > Convert it to base 36 (numbers + letters), and grab the first 9 characters
 * > after the decimal.
 *
 * @return {string}
 */
var generateId = function generateId() {
  return Math.random().toString(36).substr(2, 9);
};

var TextField = _react.default.forwardRef(function (_ref, ref) {
  var _classNames$use;

  var children = _ref.children,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? generateId() : _ref$id,
      className = _ref.className,
      label = _ref.label,
      helper = _ref.helper,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'normal' : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      inputProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["children", "id", "className", "label", "helper", "variant", "size", "tag"]);
  var controlId = [id, 'control'].join('-');
  return _react.default.createElement(Tag, {
    id: id,
    className: _utils.classNames.use('container', (_classNames$use = {}, _classNames$use[size] = size !== 'default', _classNames$use[variant] = variant !== 'normal', _classNames$use.focus = variant !== 'normal', _classNames$use)).from(styles).join(className)
  }, _react.default.createElement("input", (0, _extends2.default)({
    ref: ref,
    id: controlId,
    "aria-invalid": variant === 'error' ? 'true' : 'false',
    "aria-describedby": id + "-helper"
  }, inputProps)), _react.default.createElement("label", {
    htmlFor: controlId
  }, label), _react.default.createElement("span", {
    id: id + "-helper",
    className: styles.helper
  }, helper));
});

TextField.propTypes = {
  /**
   * Label for the text field
   */
  label: _propTypes.default.node.isRequired,

  /**
   * Size variation. Affects height only.
   */
  size: _propTypes.default.oneOf(['default', 'small', 'large']),

  /**
   * An ID that will be used to link input and label. It's necessary for
   * accessibility.
   *
   * If not passed, it will be generated automatically using a random string.
   */
  id: _propTypes.default.string,

  /**
   * Helper message to show bellow the input
   */
  helper: _propTypes.default.string,

  /**
   * Helper variation. Affects coloUr of inputs
   */
  variant: _propTypes.default.oneOf(['normal', 'focus', 'success', 'error'])
};
var _default = TextField;
exports.default = _default;